export enum eConnectionType {
  Notification,
  JustSold,
  NewVersion,
  Offer
}
